import React from 'react';
import { useTranslation } from 'react-i18next';
import AutosizerFlex from 'components/AutosizerFlex';
import { InscriptionT } from 'routes/BudgetModule/shared/entities/inscription';
import { InscriptionStatusPieChart } from './InscriptionStatusPieChart';
import { StyHeader, StyTitle, StyVerticalLayout } from './styles';

type Props = {
    filteredInscriptionData: InscriptionT[];
};

const ArbitrageChartSection = ({
    filteredInscriptionData,
}: Props): React.ReactElement => {
    const { t } = useTranslation();

    return (
        <StyVerticalLayout>
            <StyHeader>
                <StyTitle variant="body1">
                    {t('budgetProposal.inscriptionStatus')}
                </StyTitle>
            </StyHeader>
            <AutosizerFlex>
                {({ height, width }) => (
                    <InscriptionStatusPieChart
                        inscriptionsData={filteredInscriptionData}
                        height={height}
                        width={width}
                    />
                )}
            </AutosizerFlex>
        </StyVerticalLayout>
    );
};

export default ArbitrageChartSection;
